import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['button', 'popup', 'PopupBg']

    toggle(event) {
        event.preventDefault();
        if (this.buttonTarget.getAttribute('aria-expanded') === "false") {
            this.show();
        } else {
            this.hide(null);
        }
    }

    show() {
        this.buttonTarget.setAttribute('aria-expanded', 'true');
        // this.buttonTarget.classList.add('is-active');
        if (this.hasPopupBgTarget) {
            this.PopupBgTarget.classList.remove('hidden');
        }

        if (this.hasPopupTarget) {
            this.popupTarget.classList.remove('hidden');
            setTimeout(() => {
                this.popupTarget.classList.add('opacity-100', 'scale-100');
            }, 10);
        }

    }

    hide(event) {
        if (event && ((this.hasPopupTarget && this.popupTarget.contains(event.target)) || (this.hasButtonTarget && this.buttonTarget.contains(event.target)))) {
            return;
        }
        if (this.hasButtonTarget) {
            this.buttonTarget.setAttribute('aria-expanded', 'false');
        }
        if (this.hasPopupTarget) {
            this.popupTarget.classList.remove('opacity-100', 'scale-100');
            setTimeout(() => {
                if (this.hasPopupBgTarget) {
                    this.PopupBgTarget.classList.add('hidden');
                }
                this.popupTarget.classList.add('hidden');
            }, 10);
        }
    }

    remove(event) {
        this.popupTarget.classList.add('hidden')
        if (this.hasPopupBgTarget) {
            this.PopupBgTarget.classList.add('hidden')
        }
        this.popupTarget.classList.remove('opacity-100', 'scale-100');
    }

    removeParent(event) {
        let parent = this.element.parentElement?.closest('[data-controller="dropdown"]')
        let target = parent.querySelector('[data-id="block_dropdown"]')
        let bgTarget = parent.querySelector('[data-id="block_bg_dropdown"]')
        target.classList.add('hidden')
        bgTarget.classList.add('hidden')
        target.classList.remove('opacity-100', 'scale-100')
    }

    adjustPosition() {
        const button = this.buttonTarget;
        const popup = this.popupTarget;
        const gridCell = button.closest('.adjust');

        const buttonRect = button.getBoundingClientRect();
        const popupRect = popup.getBoundingClientRect();
        const gridRect = gridCell.getBoundingClientRect();
        const scrollLeft = gridCell.scrollLeft;
        const gridLeft = gridRect.left + scrollLeft;

        const spaceOnLeft = buttonRect.left - gridRect.left;
        const spaceOnRight = gridRect.right - buttonRect.right;

        popup.classList.remove('left-0', 'right-0');

        if (spaceOnRight >= popupRect.width) {
            popup.classList.add("left-0");
        } else if (spaceOnLeft >= popupRect.width) {
            popup.classList.add("right-0");
        }
    }


}
